export default __webpack_public_path__ + "img/b294b66f6c5421aff240bba902de8efe.png";